var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBotInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_2",
    "data-name": 2,
    d: "M8,16a8,8,0,1,1,8-8A8,8,0,0,1,8,16Zm0-1.6A6.4,6.4,0,1,0,1.6,8,6.4,6.4,0,0,0,8,14.4Zm0-8a.8.8,0,0,1,.8.8v4a.8.8,0,0,1-1.6,0v-4A.8.8,0,0,1,8,6.4Zm0-.8a.8.8,0,1,1,.8-.8A.8.8,0,0,1,8,5.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotInfo);
export default __webpack_public_path__ + "static/media/botInfo.ce1b85c4790b56aa7b0cab12bc6d17b5.svg";
export { ForwardRef as ReactComponent };